import * as React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';

import { Button } from '@material-ui/core';
import * as PreviewStore from '../../../app/store/PreviewStore';

import { TaskContent } from '../../../youwell-common/components';
import urls from '../../../app/urls';
import { styles as defaultStyles, getContentTranslations } from '../../../common/components/VimoTaskContent';
import { parseInternalLink } from '../../../youwell-common/taskContentUtils';
import AddCommentOverlay from './AddCommentOverlay';
import { getSpecificTaskResponses } from '../../../youwell-common/responseUtils';

const styles = theme => ({
    ...defaultStyles(theme),
    showHiddenElementsBtn: {
        display: 'none', // tmp hidden..
        float: 'right',
        top: -50,
        right: 50,
    },

});

const useStyles = makeStyles(theme => styles(theme), { name: 'PreviewTaskContent' });


const PreviewTaskContent = ({ forwardedRef, task }) => {
    const [noHiddenStateValue, setNohiddenStateValue] = React.useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();

    const translate = useSelector(state => getTranslate(state.localize));
    const allTaskResponses = useSelector(state => state.previewStore.responses);
    const allTasksDetails = useSelector(state => state.previewStore.details);
    const commentElementId = useSelector(state => state.previewStore.commentElementId);

    // task.patientProgramElementId is "undefined" but this works.. Should maybe make more robust?
    const responsesForCurrentTask = allTaskResponses && allTaskResponses[task.patientProgramElementId]
        && allTaskResponses[task.patientProgramElementId][task.id];

    const updateResponse = (responses) => {
        const responseData = {
            taskId: task.id,
            taskVersion: task.version,
            responses,
        };

        dispatch(PreviewStore.actionCreators.updateResponse(responseData));
    };

    const saveChanges = (callback) => {
        if (callback) {
            callback();
        }
    };

    const getLinkUrl = (link) => {
        const { taskOrModuleId, hash } = parseInternalLink(link);
        return `${urls.preview.home}/${taskOrModuleId}${hash}`;
    };

    const getProgramItem = id => (allTasksDetails ? allTasksDetails[id] : null);

    const toggleHiddenStates = () => {
        setNohiddenStateValue(prevState => !prevState);
    };

    return (
        <>
            <Button variant="outlined" color="primary" className={classes.showHiddenElementsBtn} onClick={toggleHiddenStates}>
                {noHiddenStateValue ? translate('preview.hideHiddenElements') : translate('preview.showHiddenElements')}
            </Button>

            <TaskContent
                ref={forwardedRef}
                TaskElementProps={{
                    noHiddenStates: noHiddenStateValue,
                    HoveredElement: AddCommentOverlay,
                    selectedElementId: commentElementId,
                }}
                className={classnames(classes.root)}
                LinkElementProps={{
                    getLinkUrl,
                }}
                task={task}
                taskResponses={responsesForCurrentTask}
                getProgramItem={getProgramItem}
                getSpecificTaskResponses={getSpecificTaskResponses(allTaskResponses, responsesForCurrentTask)}
                translations={getContentTranslations(translate)}
                onResponse={updateResponse}
                onSaveChanges={saveChanges}
            />
        </>
    );
};

PreviewTaskContent.propTypes = {
    forwardedRef: PropTypes.object,
    task: PropTypes.object.isRequired,
};

PreviewTaskContent.defaultProps = {
    forwardedRef: null,
};

const WithRef = React.forwardRef((props, ref) => <PreviewTaskContent {...props} forwardedRef={ref} />);
export default WithRef;
